
<app-form-input 
[parentForm]="parentForm"
[disabled]="disabled"
[value]="personnePhysique?.civilite" 
[label]="step12.getcivilite"
[type]="'select'"
[optionsWithCode]="optionsSelect"
[typeSelect]="optionsSelectType"
[name]="getUid()+'_SepAtt_civilite'">
</app-form-input>

<app-form-input 
[parentForm]="parentForm"
[disabled]="disabled"
 
[value]="personnePhysique?.pren" 
 
[label]="step12.getpren"
[type]="'text'" [rule]="'minSize_1|maxSize_255'" 
[name]="getUid()+'_SepAtt_pren'">
</app-form-input>

<app-form-input 
[parentForm]="parentForm"
[disabled]="disabled"
 
[value]="personnePhysique?.nom" 
 
[label]="step12.getnom"
[type]="'text'" [rule]="'required|minSize_5|maxSize_255'"
[name]="getUid()+'_SepAtt_nom'">
</app-form-input>

<app-form-input 
[parentForm]="parentForm"
[disabled]="disabled"
 
[value]="personnePhysique?.fonc" 
 
[label]="step12.getfonc"
[type]="'text'" [rule]="'minSize_1|maxSize_100'"
[name]="getUid()+'_SepAtt_fonc'">
</app-form-input>